import { ButtonFilterInputText, ButtonFilterOptions, ButtonFilterPeriod } from '@/components/custom';
import { IPeriod, ISelectOption } from '@/interfaces';
import { getSelectOptions } from '@/functions';
import { useQueryParams } from '@/hooks';
import { useCreators } from '../hooks';
import { TNullable } from '@/types';
import dayjs from 'dayjs';

const VARIABLES = {
  keyNameCreatedAt: 'createdAt',
  keyNameGender: 'gender',
  keyNameEmail: 'email',
  keyNameName: 'name'
};

const Filters = () => {

  const { updateSearchParams, urlSearchParams } = useQueryParams([]);
  const { isLoading: isLoadingCreators } = useCreators();

  const filterOptions = {
    gender: urlSearchParams.getAll(VARIABLES.keyNameGender),
    email: urlSearchParams.get(VARIABLES.keyNameEmail),
    name: urlSearchParams.get(VARIABLES.keyNameName),
    createdAt: {
      from: urlSearchParams.get(`${VARIABLES.keyNameCreatedAt}From`),
      to: urlSearchParams.get(`${VARIABLES.keyNameCreatedAt}To`)
    }
  };

  const handleOnChangeFilterPeriod = (key: string, period?: IPeriod) =>
    updateSearchParams(
      prevUrlSearchParams => {
        // Remove all existing
        prevUrlSearchParams.delete(`${key}From`);
        prevUrlSearchParams.delete(`${key}To`);
        // Add new values 
        period?.from &&
          prevUrlSearchParams.append(`${key}From`, dayjs(period.from).startOf('day').toDate().toString());
        period?.to &&
          prevUrlSearchParams.append(`${key}To`, dayjs(period.to).endOf('day').toDate().toString());
        // Return 
        return prevUrlSearchParams;
      }
    );

  const handleOnChangeFilterText = (key: string, value?: TNullable<string>) =>
    updateSearchParams(
      prevUrlSearchParams => {
        // Get current values 
        const currentValues = prevUrlSearchParams.getAll(key);
        // Remove all existing
        currentValues.forEach(l => prevUrlSearchParams.delete(key, l));
        // Add new value
        value &&
          prevUrlSearchParams.append(key, value);
        // Return 
        return prevUrlSearchParams;
      }
    );

  const handleOnChangeFilter = (key: string, options: ISelectOption[]) =>
    updateSearchParams(
      prevUrlSearchParams => {
        // Get current values 
        const currentValues = prevUrlSearchParams.getAll(key);
        // Remove all existing
        currentValues.forEach(option => prevUrlSearchParams.delete(key, option));
        // Add new values        
        options.forEach(option => prevUrlSearchParams.append(key, option.value as string));
        // Return 
        return prevUrlSearchParams;
      }
    );

  return (
    <div className='flex flex-wrap gap-2'>
      <ButtonFilterInputText
        disabled={isLoadingCreators}
        value={filterOptions.name}
        inputPlaceholder={`Nom du créateur`}
        onChange={value => handleOnChangeFilterText(VARIABLES.keyNameName, value)}
        text='Nom' />
      <ButtonFilterInputText
        disabled={isLoadingCreators}
        value={filterOptions.email}
        onChange={value => handleOnChangeFilterText(VARIABLES.keyNameEmail, value)}
        inputPlaceholder={`Email du créateur`}
        text='Email' />
      <ButtonFilterOptions
        disabled={isLoadingCreators}
        options={getSelectOptions('GenderEnum')}
        onChange={options => handleOnChangeFilter(VARIABLES.keyNameGender, options)}
        value={filterOptions.gender}
        text='Genre' />
      <ButtonFilterPeriod
        disabled={isLoadingCreators}
        onChange={value => handleOnChangeFilterPeriod(VARIABLES.keyNameCreatedAt, value)}
        value={{
          from: filterOptions.createdAt.from ? new Date(filterOptions.createdAt.from) : undefined,
          to: filterOptions.createdAt.to ? new Date(filterOptions.createdAt.to) : undefined
        }}
        text='Période de création' />
    </div>
  );

};

export default Filters;
